(() => {
  const root = document.querySelector('[data-nova-chat]');
  if (!root) return;

  const launcher = root.querySelector('[data-nova-chat-open]');
  const fallback = root.querySelector('[data-nova-chat-fallback]');
  const close = root.querySelector('[data-nova-chat-close]');
  const nativeAction = root.querySelector('[data-nova-chat-native]');
  let nativeButton = null;

  const nativeChatButton = () => {
    const visibleButton = [...document.querySelectorAll('button[aria-label="Chat"], button[aria-label*="chat" i]')]
      .find((button) => !root.contains(button));
    if (visibleButton) return visibleButton;

    const hosts = document.querySelectorAll('#ShopifyChat, shopify-chat, [data-shopify-chat]');
    for (const host of hosts) {
      const button = host.shadowRoot?.querySelector('button');
      if (button) return button;
    }
    return null;
  };

  const prepareNativeChat = () => {
    nativeButton = nativeChatButton();
    if (!nativeButton) return false;

    nativeButton.setAttribute('data-nova-native-chat', 'true');
    nativeButton.setAttribute('aria-hidden', 'true');
    nativeButton.setAttribute('tabindex', '-1');
    Object.assign(nativeButton.style, {
      position: 'fixed',
      inset: 'auto 0 0 auto',
      width: '1px',
      height: '1px',
      padding: '0',
      border: '0',
      opacity: '0',
      pointerEvents: 'none',
      overflow: 'hidden',
    });
    root.dataset.nativeChatReady = 'true';
    if (nativeAction) nativeAction.hidden = false;
    return true;
  };

  const setFallback = (open) => {
    fallback.hidden = !open;
    launcher.setAttribute('aria-expanded', String(open));
    if (open) close.focus();
    else launcher.focus();
  };

  launcher.addEventListener('click', () => {
    setFallback(fallback.hidden);
  });

  nativeAction?.addEventListener('click', () => {
    if (!nativeButton && !prepareNativeChat()) return;
    setFallback(false);
    nativeButton?.click();
  });

  close.addEventListener('click', () => setFallback(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !fallback.hidden) setFallback(false);
  });

  if (!prepareNativeChat()) {
    const observer = new MutationObserver(() => {
      if (prepareNativeChat()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }
})();
